import type { AppState } from '../../common/types';

export const getArchiveWidgetData = (state: AppState) => state.archiveWidget;
